export default "__VITE_ASSET__DW_Yp9rs__$_?inline__"